module.exports = __webpack_public_path__ + "static/media/7.b5516d77.png";